import { push } from 'connected-react-router';
import {
  LOG_IN_PENDING,
  LOG_IN_SUCCESS,
  LOG_IN_FAILED,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_FAILED,
  VERIFY_TOKEN_PENDING,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILED,
} from '../actionTypes';

import { MAP_VIEW } from '../../routes/path';

import {
  logInService,
  signOutService,
  verifyTokenService,
} from '../../service/auth.service';

export const logInPending = () => ({
  type: LOG_IN_PENDING,
});

export const logInSuccess = admin => ({
  type: LOG_IN_SUCCESS,
  payload: admin,
});

export const logInFailed = error => ({
  type: LOG_IN_FAILED,
  payload: error,
});

export const logInAction = user => async dispatch => {
  try {
    dispatch(logInPending());
    const response = await logInService(user);
    if (response.data?.error) {
      dispatch(logInFailed(response.data.error.message));
    } else {
      dispatch(logInSuccess(response));
      dispatch(push(MAP_VIEW));
    }
  } catch (error) {
    dispatch(logInFailed(error));
  }
};

//  SIGN_OUT_SUCCESS
export const signOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS,
});

// SIGN_OUT_FAILED
export const signOutFailed = () => ({
  type: SIGN_OUT_FAILED,
});

// SIGN IN ACTION FUNCTION
export const signOutAction = () => dispatch => {
  try {
    const isUserLoggedOut = signOutService();
    if (isUserLoggedOut) {
      dispatch(signOutSuccess());
    } else {
      dispatch(signOutFailed());
    }
  } catch (error) {
    dispatch(signOutFailed());
  }
};

export const verifyTokenPending = () => ({
  type: VERIFY_TOKEN_PENDING,
});

export const verifyTokenSuccess = admin => ({
  type: VERIFY_TOKEN_SUCCESS,
  payload: admin,
});

export const verifyTokenFailed = () => ({
  type: VERIFY_TOKEN_FAILED,
});

export const verifyTokenAction = () => async dispatch => {
  try {
    dispatch(verifyTokenPending());
    const response = await verifyTokenService();
    if (response) {
      dispatch(verifyTokenSuccess(response));
    } else {
      dispatch(verifyTokenFailed());
    }
  } catch (error) {
    dispatch(verifyTokenFailed());
  }
};
